module.exports = __webpack_public_path__ + "static/copper_dragon-5d22fd6fbb328f509d2ee35f146c836f.jpg";